import React, { memo } from "react";
import { Card, CardContent, Typography, Box, Stack, useTheme, useMediaQuery } from "@mui/material";
import { useIntl } from "react-intl";
import look_out from "../../img/look_out.png";

export const StartTutoringMotivation = memo(({
  subscriberCount,
  areTeachingsAvailable,
}) => {
  const intl = useIntl();
  const muiTheme = useTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));

  const startTutoringMotivationText = intl.formatMessage(
    { id: "teacher.start-tutoring-motivation.motivation" },
    {
      number: subscriberCount,
      breakLine: <br />,
      plural: subscriberCount !== 1,
    }
  );

  const emptyMotivation1 = intl.formatMessage({
    id: "teacher.start-tutoring-motivation.motivation-empty-1",
  });
  const emptyMotivation2 = intl.formatMessage({
    id: "teacher.start-tutoring-motivation.motivation-empty-2",
  });
  const emptyMotivation3 = intl.formatMessage({
    id: "teacher.start-tutoring-motivation.motivation-empty-3",
  });

  const NoTutorsMotivationText = () => {
    return (
      <Typography
        variant="h4"
        sx={{
          fontWeight: 'bold',
          fontSize: { xs: '16px', sm: '18px', md: '24px', lg: '26px' },
          lineHeight: { xs: 1.5, md: 1.9 },
          textAlign: 'center',
          wordWrap: 'break-word',
          overflowWrap: 'break-word',
          hyphens: 'auto',
        }}
      >
        {emptyMotivation1}{" "}
        <Box
          component="span"
          sx={{
            color: 'primary.main',
            fontWeight: 'bold',
          }}
        >
          {emptyMotivation2}
        </Box>{" "}
        {emptyMotivation3}
      </Typography>
    );
  };

  return (
    <Card
      sx={{
        width: { xs: '100%', sm: '95%', md: '100%', lg: '110%', xl: '120%' },
        maxWidth: '100%',
        borderRadius: { xs: '20px 40px 40px 20px', md: '20px 60px 60px 20px' },
        backgroundColor: '#faeff0',
        mt: { xs: 2, md: 7.5 },
        mb: { xs: 4, md: 22.5 },
        alignSelf: 'flex-start',
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: '0px 6px 16px rgba(0, 0, 0, 0.15)',
        },
        // Ensure it never overflows the container
        overflow: 'hidden',
      }}
    >
      <CardContent sx={{ p: 0 }}>
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          alignItems="center"
          spacing={{ xs: 2, md: 0 }}
          sx={{ minHeight: { xs: 'auto', md: 200 } }}
        >
          {/* Image Section */}
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              flexShrink: 0,
              maxWidth: { xs: '100%', md: '40%' },
            }}
          >
            <Box
              component="img"
              src={look_out}
              sx={{
                width: { xs: 120, sm: 150, md: 250, lg: 300 },
                height: { xs: 120, sm: 150, md: 215, lg: 258 },
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>

          {/* Text Section */}
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent: 'center',
              px: { xs: 2, sm: 3, md: 4, lg: 7.5 },
              py: { xs: 2, md: 0 },
              minWidth: 0, // Allow text to shrink
              overflow: 'hidden',
            }}
          >
            {!areTeachingsAvailable ? (
              <NoTutorsMotivationText />
            ) : (
              <Typography
                variant="h4"
                sx={{
                  fontWeight: 'bold',
                  fontSize: { xs: '16px', sm: '18px', md: '24px', lg: '26px' },
                  lineHeight: { xs: 1.5, md: 1.9 },
                  textAlign: 'center',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  hyphens: 'auto',
                }}
              >
                {startTutoringMotivationText}
              </Typography>
            )}
          </Box>
        </Stack>
      </CardContent>
    </Card>
  );
});

StartTutoringMotivation.displayName = 'StartTutoringMotivation';

